export const BACKGROUND_COLOR = ["beige", "blue", "purple", "green"];

export const BACKGROUND_IMAGE_NAME = ["first", "second", "third", "fourth"];

export const BACKGROUND_IMAGE = {
  first:
    "https://i.pinimg.com/originals/65/ed/0d/65ed0d5ca1be4dfc8fb3427a14acfca9.jpg",
  second:
    "https://i.pinimg.com/564x/6c/42/ba/6c42ba5d285e0554e580b255f0d6b4dc.jpg",
  third:
    "https://i.pinimg.com/originals/a8/5f/c8/a85fc84c65c7ad9471b06c31f7a30061.jpg",
  fourth:
    "https://i.pinimg.com/originals/ff/59/23/ff592396e3bc5fd4a0c91d14eccc78fd.jpg",
};
